import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './reusable/global/NavMenu';
import { NavMenuAuth } from './reusable/global/NavLogin';
import { Footer } from './reusable/global/Footer';
import { AuthContext } from "../store/provider/AuthProvider";
import localStorageCustom from '../utilitarios/localStorage';
// import { browserHistory } from "react-router";
// import { createBrowserHistory } from "history";
// import PropTypes from 'prop-types' 

export class Layout extends Component {
  static displayName = Layout.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      hideNav: false
    };
    this.validateState = this.validateState.bind(this);
  }

  isLoggedInChange(value) {
    this.setState({ isLoggedIn: value });
  }

  componentDidUpdate(prevProps, prevState) {
    // const auth = this.context;
    // // debugger;
    // const { pathname } = window.location;

    // const isLoggedIn = ["/linea-negocio", "/razon-social"].includes(pathname.toLowerCase()) ? false : auth.isLoggedIn;
    // // const hideNav = auth.hideNav;
    // const hideNav = ["/"].includes(pathname.toLowerCase()) ? true : false;
    // if (prevState.isLoggedIn != isLoggedIn || prevState.hideNav != hideNav) {
    // debugger;
    // console.log(hideNav);
    // // debugger;
    //   this.setState({
    //     isLoggedIn: isLoggedIn,
    //     hideNav: hideNav
    //   })
    // }
  }

  validateState() {
    const auth = this.context;

    const { history } = this.props;
    const { pathname } = history.location;
    var isLoggedIn = localStorageCustom.prototype.getToken() ? true : false;
    const hideNav = isLoggedIn ? true : ["/"].includes(pathname.toLowerCase());
    isLoggedIn = ["/linea-negocio", "/razon-social"].includes(pathname.toLowerCase()) ? false : isLoggedIn;
    this.setState({
      isLoggedIn: isLoggedIn,
      hideNav: hideNav
    });
  }

  componentDidMount() {
    const { history } = this.props;
    this.validateState();
    history.listen(this.validateState);
  }

  classWrapper(path) {
    switch (path) {
      case "/" : case "/solicitar-acceso" : case "/recuperar-contrasenia":
        return "pt-0";
      case "/perfil":
        return "perfil-page";
      default:
        return "";
    }
  }

  render() {
    const { isLoggedIn, hideNav } = this.state;
    const { history } = this.props;
    const { pathname } = history.location;
    console.log('pathname',pathname)
    return (
      <div id="wrapper" className={this.classWrapper(pathname)}>
        <NavMenu isLoggedIn={isLoggedIn} />
        <NavMenuAuth isLoggedIn={isLoggedIn} hideNav={hideNav} />
        {this.props.children}
        <Footer isLoggedIn={isLoggedIn} />
      </div>
    );
  }
}